import {
  AppstoreOutlined,
  CloudUploadOutlined,
  Flex,
  Layout,
  SettingOutlined,
  DatabaseOutlined,
  Typography
} from 'core-ui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import Header from './components/Header';
import Logo from './components/Logo';
interface MenuItem {
  label: ReactNode;
  key: string;
  children?: MenuItem[];
  icon?: ReactNode;
}

const { Title } = Typography;

const MainLayout = () => {
  const { t } = useTranslation();

  const menuItems: any = [
    {
      key: '/tile',
      label: (
        <Link to="/tile">
          <Flex align="center">
            <AppstoreOutlined />
            <span>{t('Tile.title')}</span>
          </Flex>
        </Link>
      ),
      title: '商品一覧'
    },

    {
      key: '/texture',
      label: (
        <Link to="/texture">
          <Flex align="center">
            <CloudUploadOutlined />
            <span>{t('Media.title')}</span>
          </Flex>
        </Link>
      ),
      title: '模様一覧'
    },
    {
      key: '/color',
      label: (
        <Link to="/color">
          <Flex align="center">
            <DatabaseOutlined />
            <span>{t('Color.title')}</span>
          </Flex>
        </Link>
      ),
      title: 'カラー一覧'
    },
    {
      key: '/settings',
      label: (
        <Link to="/settings">
          <Flex align="center">
            <SettingOutlined />
            <span> {t('Setting.title')}</span>
          </Flex>
        </Link>
      ),
      title: 'パスワード設定'
    }
  ];

  const currentRoute = getsAllRoutes(menuItems)
    .filter((route) => location.pathname.includes(route))
    .sort((a, b) => b.length - a.length)[0];

  const currentTitle = menuItems.find(
    (item: any) => item.key === currentRoute
  )?.title;

  return (
    <Layout
      contentWrapperStyle={{ padding: 0 }}
      headerContent={<Header />}
      logoContent={<Logo />}
      logoClassName="flex justify-center items-center"
      menuItems={menuItems}
      siderStyle={{
        overflowX: 'hidden',
        boxShadow: 'none'
      }}
      contentStyle={{
        overflow: 'auto',
        padding: 0
      }}
      menuProps={{
        selectedKeys: [currentRoute],
        style: { overflowY: 'unset', padding: 0 }
      }}
    >
      <Flex className="flex justify-between items-center p-4">
        <Title level={4} className="!m-0">
          {currentTitle}
        </Title>
      </Flex>

      <div className="p-5 bg-[#f2f2f2]">
        <div className="bg-white">
          <Outlet />
        </div>
      </div>
    </Layout>
  );
};

export default MainLayout;

const getsAllRoutes = (routes: MenuItem[]) => {
  const allRoutes: string[] = [];
  routes.forEach((route) => {
    allRoutes.push(route.key);
    if (route.children) allRoutes.push(...getsAllRoutes(route.children));
  });
  return allRoutes.filter((route) => route.startsWith('/'));
};
